/**
 * @fileoverview gRPC-Web generated client stub for com.mu.logistic.api
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

import * as grpcWeb from 'grpc-web';

import {
  AutocompleteLocationsRequest,
  AutocompleteLocationsResponse,
  GeoDistanceRequest,
  GeoDistanceResponse,
  GeocodePositionRequest,
  GeocodePositionWithCityRequest,
  GeocodeRequest,
  GeocodeResponse,
  GetPolygonsRequest,
  GetPolygonsResponse,
} from './geologic.api_pb';

export class GeologicServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: string };

  constructor(hostname: string, credentials: null | { [index: string]: string }, options: null | { [index: string]: string }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGeocode = new grpcWeb.AbstractClientBase.MethodInfo(
    GeocodeResponse,
    (request: GeocodeRequest) => {
      return request.serializeBinary();
    },
    GeocodeResponse.deserializeBinary
  );

  geocode(request: GeocodeRequest, metadata: grpcWeb.Metadata | null, callback: (err: grpcWeb.Error, response: GeocodeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/Geocode',
      request,
      metadata || {},
      this.methodInfoGeocode,
      callback
    );
  }

  methodInfoReverseGeocode = new grpcWeb.AbstractClientBase.MethodInfo(
    GeocodeResponse,
    (request: GeocodePositionRequest) => {
      return request.serializeBinary();
    },
    GeocodeResponse.deserializeBinary
  );

  reverseGeocode(
    request: GeocodePositionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GeocodeResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/ReverseGeocode',
      request,
      metadata || {},
      this.methodInfoReverseGeocode,
      callback
    );
  }

  methodInfoReverseGeocodeWithCity = new grpcWeb.AbstractClientBase.MethodInfo(
    GeocodeResponse,
    (request: GeocodePositionWithCityRequest) => {
      return request.serializeBinary();
    },
    GeocodeResponse.deserializeBinary
  );

  reverseGeocodeWithCity(
    request: GeocodePositionWithCityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GeocodeResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/ReverseGeocodeWithCity',
      request,
      metadata || {},
      this.methodInfoReverseGeocodeWithCity,
      callback
    );
  }

  methodInfoDistanceGeolocation = new grpcWeb.AbstractClientBase.MethodInfo(
    GeoDistanceResponse,
    (request: GeoDistanceRequest) => {
      return request.serializeBinary();
    },
    GeoDistanceResponse.deserializeBinary
  );

  distanceGeolocation(
    request: GeoDistanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GeoDistanceResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/DistanceGeolocation',
      request,
      metadata || {},
      this.methodInfoDistanceGeolocation,
      callback
    );
  }

  methodInfoGetPolygons = new grpcWeb.AbstractClientBase.MethodInfo(
    GetPolygonsResponse,
    (request: GetPolygonsRequest) => {
      return request.serializeBinary();
    },
    GetPolygonsResponse.deserializeBinary
  );

  getPolygons(
    request: GetPolygonsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: GetPolygonsResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/GetPolygons',
      request,
      metadata || {},
      this.methodInfoGetPolygons,
      callback
    );
  }

  methodInfoAutocompleteLocations = new grpcWeb.AbstractClientBase.MethodInfo(
    AutocompleteLocationsResponse,
    (request: AutocompleteLocationsRequest) => {
      return request.serializeBinary();
    },
    AutocompleteLocationsResponse.deserializeBinary
  );

  autocompleteLocations(
    request: AutocompleteLocationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error, response: AutocompleteLocationsResponse) => void
  ) {
    return this.client_.rpcCall(
      this.hostname_ + '/com.mu.logistic.api.GeologicService/AutocompleteLocations',
      request,
      metadata || {},
      this.methodInfoAutocompleteLocations,
      callback
    );
  }
}
